import { Queryable } from "./queryable";

export interface ConsultingIncome {
    id?: string
    // Division the row rolls up to (the row itself for division rows)
    divisionId?: string | null
    department: string
    // Departments under a division row (built on the client)
    subRows?: ConsultingIncome[]
    actual: number,
    workInHand: number,
    budget: number
}

export interface ConsultingIncomeReport {
    departments: ConsultingIncome[]
    divisions: ConsultingIncome[]
}

export interface IConsultingIncomeQuery extends Queryable {
    fromFiscalPeriod?: number
    toFiscalPeriod?: number
    branchIds?: string[]
}

export class ConsultingIncomeUI {

    static format(value: number): string {
        const abs = Math.abs(value).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        return value < 0 ? `-${abs}` : abs
    }

    static colorClass(value: number): string {
        if (value > 0) return 'cell-positive'
        if (value < 0) return 'cell-negative'
        return 'cell-neutral'
    }

    static cellBg(value: number, neutralBg: string = 'var(--bs-warning-bg-subtle)'): string {
        if (value > 0) return 'var(--financial-positive-bg)'
        if (value < 0) return 'var(--financial-negative-bg)'
        return neutralBg
    }


}
